import {
  Component,
  DestroyRef,
  inject,
  OnInit,
} from '@angular/core';
import {
  ActivatedRoute,
  Router,
} from '@angular/router';

import { componentDestroyed } from 'ng2-rx-componentdestroyed';
import {
  share,
  takeUntil,
} from 'rxjs/operators';

import { CommonService } from '@services/common.service';
import { YTBSEOService } from '@services/ytb-seo.service';
import { untilDestroyed } from '@ngneat/until-destroy';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-issueTicket',
    templateUrl: './issueTicket.component.html',
    providers: []
})
export class IssueTicketComponent implements OnInit {
    isLoading: boolean = false;
    userNotFounfShowFail: boolean = false;
    userNotFoundShowSuccess: boolean = false;
    userNotFoundMessageInfo: any = {};
      private destroyRef = inject(DestroyRef);
    
    constructor(
        private commonService: CommonService, private route: ActivatedRoute, private router: Router,private ytbseo:YTBSEOService) { }

    ngOnInit() {



        this.route.queryParams.subscribe(res => {
            if (res && Object.keys(res).length != 0) {
                this.isLoading = true;
                this.commonService.issueTicket({referenceNumber : res.ticketId});
            } else {
                  this.commonService.logError({
                logLevel: "Error page Navigation Before",
                message:
                  "Issue Ticket using query params From Issue Ticket Component "
              });
                this.router.navigate(["error"]);
            }

            let url = this.router.url.split('?');
            setTimeout(() => {
    
              this.ytbseo.createCanonicalURL(this.router.url);
              this.ytbseo.setDynamicTitle(url[0], { check:'Check' });
              this.ytbseo.updateMetaTags(
                'desc',
                { 'replaceKeywords': { 'check':'Check' } },
                'Homepage');
            }, 1000);

        });

        this.commonService.onFailure
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe((response) => {
          if (response != null && response != undefined) {
            if ((response.exceptionSource === 'issueTicket')) {
                // this.userNotFounfShowFail = true;
                // this.isLoading = false;
                // this.userNotFoundMessageInfo['uiErrorMessage'] = ["Unable to Issue Ticket at this time"];
            }
          }
        });


        this.commonService.issueTicketSuccess$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(res => {
            if (res) {
                this.userNotFounfShowFail = false;
                this.userNotFoundShowSuccess = false;
                this.isLoading = false;
                this.userNotFoundMessageInfo = res.messageInfo;
                if (res.successCode) {
                    this.userNotFoundShowSuccess = true;
                } else {
                    this.userNotFounfShowFail = true;
                }
            }
        })
    }

    ngOnDestroy() {
        this.commonService.dispose();
    }
}